import { axios } from '@Root/API'

export const get = id => {
	return axios.get(`student/venue/${id}`)
}
